import { GetSpecifierHandler } from '../types';

export const getHcpSpecifier: GetSpecifierHandler = specifiers =>
    specifiers.find(s => s.name === 'hcp');
export const getTotalSpecifier: GetSpecifierHandler = specifiers =>
    specifiers.find(s => s.name === 'total');
